import classes from "./Notification.module.css";
import NotificationText from "./NotificationText";
const Notification = (props) => {
  const {
    image,
    unread,
    numberOfUnreadMessages,
  } = props;
  return (
    <section
      className={
        classes.notification +
        " " +
        `${
          unread && numberOfUnreadMessages > 0
            ? classes.unread
            : ""
        }`
      }
    >
      <div
        className={classes.image}
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></div>
      <NotificationText {...props} />
    </section>
  );
};

export default Notification;
